import React from 'react';

import { WidgetProps } from '@rjsf/core';
import { List } from 'semantic-ui-react'

type TOption = { label: string, value: any };

const CheckboxesWidget = (props: WidgetProps) => {
  const {
    id,
    options,
    value,
    formContext,
    placeholder
  } = props


  const enumOptions = options.enumOptions as TOption[];
  const enumDisabled = options.enumDisabled as any[];
  const inline = Boolean(options.inline)

  const isChecked = (option: TOption) => (value || "").indexOf(option.value) !== -1
  const isDisabled = (option: TOption) => enumDisabled.indexOf(option.value) != -1

  const selected = enumOptions.length ? enumOptions.filter(isChecked) : [];


  return (
    <List className="field-checkboxes" inline={inline === true} style={{ margin: "0.5em 0em" }}>
      {selected.length ?
        selected.map((option: any, index: number) => {
          const itemDisabled = Boolean(enumDisabled && isDisabled(option));
          return (
            <List.Item disabled={itemDisabled} key={index} id={`${id}_${index}`} >
              {option.label}
            </List.Item>
          )
        })
        : placeholder || formContext.emptyValue}
    </List >
  )
};

export default CheckboxesWidget;
